<template>
  <div class="journal-details">
    <p class="crumbs">
      <router-link class="color-gray hover-blue" to="/journal"
        >期刊介绍>
      </router-link>
      <router-link
        v-if="curNav"
        :to="`/journal?curNav=${curNav}`"
        class="hover-blue"
        >{{ curNav === 1 ? "最新文章" : "历史文章" }}>
      </router-link>
      文章详情页
    </p>
    <div class="card">
      <p class="title-ch">{{ info["paperTitle"] }}</p>
      <p class="title-en">{{ info["spare1"] }}</p>
      <p class="info">
        <span class="label"> 作者：</span
        ><span class="value">{{ info["authorName"] }}</span>
        <span class="label"> 年度：</span
        ><span class="value">{{ info["years"] }}年</span>
        <span class="label"> 期号：</span
        ><span class="value">第{{ info["issue"] }}期 </span>
        <span v-if="info.columnId" class="label"> 栏目：</span
        ><span v-if="info.columnId" class="value">{{ info["columnId"] }}</span>
      </p>
      <p class="tag">
        <span class="label">关键词：</span>{{ info["keyword"] }}
      </p>
      <p v-if="info.infoAbstract" class="info">
        <span class="label"> 摘要：</span>
        <span class="value">{{ info["infoAbstract"] }}</span>
      </p>
      <img
        v-if="imgSrc"
        :src="imgSrc"
        alt=""
        style="width: 100%; height: auto"
      />
      <!--      @page-loaded Number pdf某个页面加载成功回调，number为页面索引值；-->
      <pdf
        v-if="pdfSrc"
        :page="currentPage"
        :src="pdfSrc"
        class="pdf-v"
        @loaded="loadPdfHandler"
        @progress="loadedRatio = $event"
        @num-pages="pageCount = $event"
        @page-loaded="currentPage = $event"
      ></pdf>
      <div
        v-if="loadedRatio === 1 && pageCount > 0 && pdfSrc"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <el-pagination
          :current-page="1"
          :page-size="1"
          :total="pageCount"
          background
          layout="prev, pager, next"
          @size-change="nextPage"
          @current-change="nextPage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import pdf from "vue-pdf";

export default {
  name: "JournalDetails",
  data() {
    return {
      info: {},
      pageCount: 10,
      currentPage: 1,
      loadedRatio: 0,
      pdfSrc: null,
      curNav: null,
      imgSrc: null,
    };
  },
  components: {
    pdf,
  },
  // watch: {
  //   currentPage: {
  //     handler(newVal) {
  //       console.log("newVal", newVal, this.pageCount);
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
  mounted() {},
  created() {
    if (this.$route.query.id) {
      this.getDetails(this.$route.query.id);
    }
    if (this.$route.query.curNav) {
      this.curNav = this.$route.query.curNav * 1;
    }
  },
  methods: {
    getDetails(id) {
      this.$request.getJournalDetails(id).then((res) => {
        if (res.code === 200) {
          this.info = res.data;
          const fileType = this.getFileExtension(res.data.manuscriptUploading);
          if (fileType === "pdf") {
            this.pdfSrc = res.data.manuscriptUploading;
          } else if (fileType === "jpg" || fileType === "png") {
            this.imgSrc = res.data.manuscriptUploading;
          }
        }
      });
    },
    getFileExtension(filename) {
      const regex = /\.([^.]+)$/;
      const match = filename.match(regex);
      return match ? match[1] : null;
    },
    nextPage(page) {
      this.currentPage = page;
    },
    // pdf加载时
    loadPdfHandler() {
      // 加载的时候先加载第一页
      // this.currentPage = 1;
      this.$nextTick(() => {
        this.currentPage = 1;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.journal-details {
  width: 1180px;
  margin: 40px auto;

  .pdf-v {
    margin-top: 20px;
  }

  .crumbs {
    font-size: 16px;
    color: #333333;
  }

  .card {
    width: 1180px;
    padding: 30px 60px;
    margin-top: 20px;
    //height: 2296px;
    background: #f7f7f7;

    .title-ch {
      font-size: 20px;
      font-weight: bold;
      color: #000000;
      line-height: 30px;
      word-wrap: break-word;
      text-align: justify;
    }

    .title-en {
      font-size: 16px;
      color: #333333;
      line-height: 30px;
      word-wrap: break-word;
      text-align: justify;
    }

    .info {
      margin-top: 10px;
      font-size: 14px;
      color: #333333;
      line-height: 30px;
    }

    .label {
      font-weight: bold;
    }

    .tag {
      .label {
        font-weight: bold;
        color: #333333;
      }

      font-size: 14px;
      color: #1b1bf6;
      line-height: 30px;
    }
  }
}
</style>
